enum ECInputWithSelectMode {
  HORIZONTAL = 'horizontal',
  MONOLITH = 'monolith',
  DEFAULT = 'default',
}

export default ECInputWithSelectMode;
